import classNames from "classnames"
import useTranslation from "next-translate/useTranslation"
import Link from "next/link"

import { IProject } from "@api/schema"
import Icon from "@components/common/Icon"
import { Routes, routeWithParams } from "@services/routes"

interface IProps {
  project: IProject
  className?: string
}

/**
 * provides a link to the page to apply for a project membership
 * looking like a button
 */
const ProjectApplyButton: React.FC<IProps> = ({ project, className }: IProps) => {
  const { t } = useTranslation("common")
  const finalClassName = classNames("btn primary-btn", className)

  return <Link href={routeWithParams(Routes.ProjectApplication, { slug: project.slug || project.id })}>
    <a className={finalClassName}>
      <Icon name="user-add" size={25} />
      {t("goto.memberApplicationShort")}
    </a>
  </Link>
}

export default ProjectApplyButton
